const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'CHECK_DEVICE_ZABBIX_HOST_REQUEST') {
        return {
            ...state,
            [action.actionParams.deviceId]: {
                ...state[action.actionParams.deviceId],
                isLoading: true,
            },
        };
    }

    if (action.type === 'CHECK_DEVICE_ZABBIX_HOST_SUCCESS') {
        return {
            ...state,
            [action.actionParams.deviceId]: {
                hostId: action.payload ?? undefined,
                isLoading: false,
            },
        };
    }

    if (action.type === 'RESET_DEVICE_ZABBIX_HOST') {
        return {
            ...state,
            [action.actionParams.deviceId]: {
                hostId: undefined,
                isLoading: false,
            },
        };
    }

    return state;
}

export default reducer;
